<div fxLayout="column" fxLayoutAlign="start stretch" class="ht100">
  <mat-tab-group class="ht100">
    <mat-tab label="{{'FOCUS.REACTIVOS.STEPS.1.TITULO' | translate}}">
      <ng-template matTabContent>
        <reactivos class="ht100" (pasoCompletoFinal)="pasoCompletoFinal($event)"
        (actualizarAdicionales)="actualizarAdicionales($event)"
        ></reactivos>
      </ng-template>
    </mat-tab>
    <!-- <mat-tab label="Ordenar Reactivos">
      <ng-template matTabContent>
        <ordenarReacti class="ht100"
        ></ordenarReacti>
      </ng-template>
    </mat-tab> -->
    <mat-tab label="{{'FOCUS.REACTIVOS.STEPS.2.TITULO' | translate}}">
      <ng-template matTabContent>
        <traducciones class="ht100"
        (actualizarAdicionales)="actualizarAdicionales($event)"
        ></traducciones>
      </ng-template>
    </mat-tab>
    <mat-tab label="{{'FOCUS.REACTIVOS.STEPS.3.TITULO' | translate}}">
      <ng-template matTabContent>
        <preview class="ht100"></preview>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

  <div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
    <button *ngIf="!pasoCompleto" (click)="completarPaso()" mat-fab aria-label="boton completar paso"
      matTooltip="{{'CERTIFICAR.REACTIVOS.STATUS.PEND' | translate}}" matTooltipPosition="left" class="undone mr-20">
      <mat-icon>done</mat-icon>
    </button>
    <button *ngIf="pasoCompleto"  mat-raised-button class="done mr-20">
      {{'CERTIFICAR.REACTIVOS.STATUS.DONE' | translate}}
      <mat-icon class="ml-20">done</mat-icon>
    </button>

    <!-- desbloquearPaso -->
    <button *ngIf="pasoCompleto && (validationUser || desbloqueoEstatus)" (click)="desbloquearReactivos()" mat-fab aria-label=""
      matTooltip="{{'CERTIFICAR.REACTIVOS.STATUS.LOCK' | translate}}" matTooltipPosition="left" class="undone mr-20"
      >
      <mat-icon>lock_open</mat-icon>
    </button>

    <button *ngIf="!pasoCompleto && (validationUser || desbloqueoEstatus)" (click)="desbloquearReactivos()" mat-raised-button class="reopen mr-20">
      {{'CERTIFICAR.REACTIVOS.STATUS.UNLOCK' | translate}}
      <!-- <mat-icon class="ml-20">lock_open</mat-icon> -->
    </button>
  </div>


</div>
